// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"CheckboxesWidget_checkboxContainer__33NOz","label":"CheckboxesWidget_label__HtnWi"};